import { z } from 'zod'
import math from "@/plugins/mathjs"

export type FrontendDiscountRate = {
  value: number
  type: 'frontend'
}

export type BackendDiscountRate = {
  value: number
  type: 'backend'
}

export type DiscountRate = FrontendDiscountRate | BackendDiscountRate

export type FrontendAmount = {
  value: number
  type: 'frontend'
}

export type BackendAmount = {
  value: number
  type: 'backend'
}
export type Amount = FrontendAmount | BackendAmount

export class DiscountRateConverter {
  static toFrontendRawValue(backendValue: number, ratio: number = 10): number {
    return parseFloat(math.multiply(math.bignumber(backendValue), ratio).toString())
  }

  static toBackendRawValue(frontendValue: number, ratio: number = 10): number {
    return parseFloat(math.divide(math.bignumber(frontendValue), ratio).toString())
  }

  static toFrontendValue(backendValue: BackendDiscountRate, ratio: number = 10): FrontendDiscountRate {
    return { value: parseFloat(math.multiply(math.bignumber(backendValue.value), ratio).toString()), type: 'frontend' }
  }

  static toBackendValue(frontendValue: FrontendDiscountRate, ratio: number = 10): BackendDiscountRate {
    return { value: parseFloat(math.divide(math.bignumber(frontendValue.value), ratio).toString()), type: 'backend' }
  }
}

// 使用 Zod 进行数据验证
export const BackendDiscountRateSchema = z.number().min(0).max(1)
export const FrontendDiscountRateSchema = z.number().min(0).max(10)

export class AmountConverter {
  static toFrontendRawValue(backendValue: number): number {
    return parseFloat(math.divide(math.bignumber(backendValue), 100).toString())
  }

  static toBackendRawValue(frontendValue: number): number {
    return parseFloat(math.multiply(math.bignumber(frontendValue), 100).toString())
  }

  static toFrontendValue(backendValue: BackendAmount): FrontendAmount {
    return { value: parseFloat(math.divide(math.bignumber(backendValue.value), 100).toString()), type: 'frontend' }
  }

  static toBackendValue(frontendValue: FrontendAmount): BackendAmount {
    return { value: parseFloat(math.multiply(math.bignumber(frontendValue.value), 100).toString()), type: 'backend' }
  }
}

// export const BackendAmountSchema = z.number().min(0)
// export const FrontendAmountSchema = z.number().min(0)
